export default __webpack_public_path__ + "static/media/illustration-man-megaphone.bf5f2ca3.svg";